import { Box, Grid, Theme, Typography } from "@mui/material";
import { ViewProfileProps } from "../types";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React from "react";
import { SubHeading } from "../../investors/components";
import { getUniqueIdentityText } from "../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";

export default function RelatedPersonDetails({ overviewData }: { overviewData: Partial<ViewProfileProps> }): JSX.Element {
    const { applicants } = overviewData;
    const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'customColors.infoCard',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Typography   variant='h2' sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[500], mb: '9px' })}>
                            Related Person Details
                        </Typography>
                        {applicants?.map((applicant, index: number) => {
                            const title = [
                                'First Applicant Details',
                                'Second Applicant Details',
                                'Third Applicant Details',
                            ][index];
                            return (
                                <React.Fragment key={applicant.id}>
                                    <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                                    {applicant.relatedpersons?.length === 0 ? (
                                        <Grid
                                            xs={12}
                                            sm={12}
                                            sx={{
                                                fontSize: 16,
                                                fontWeight: 600,
                                                color: 'text.primary',
                                                textAlign: 'center',
                                                // background: 'black',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                my: 3,
                                            }}>
                                            No Related Persons
                                        </Grid>
                                    ) : (
                                        applicant.relatedpersons?.map((related, index: number) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <Grid item xs={12} sm={12}>
                                                        <Typography
                                                            sx={{
                                                                color: '#2057a6',
                                                                fontSize: '14px',
                                                                fontWeight: 550,
                                                                mt: 1,
                                                            }}>
                                                            {`Related Person ${index + 1}`}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid
                                                        item
                                                        container

                                                        rowSpacing={3}
                                                        columnSpacing={5.5}
                                                        direction="row"

                                                    >
                                                        <KeyValue
                                                            title={`Name`}
                                                            description={related?.name}
                                                            sx={{ mt: 0 }}
                                                        />
                                                        <KeyValue
                                                            title={'Relationship Type'}
                                                            description={
                                                                related.relationshipType !== 'OTHERS'
                                                                    ? related.relationshipType
                                                                    : related.relationshipTypeOther
                                                            }
                                                        />
                                                        <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={related.panNo} />
                                                    </Grid>

                                                </React.Fragment>
                                            );
                                        })
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </Grid>
                </Box>
            </Box >
        </>
    )
}